import Pagination from '@/components/helpers/Pagination'
import { cloneDeep, debounce } from 'lodash'

const fetchableItemsMixin = {
  components: {
    Pagination
  },
  data: function() {
    return {
      items: {
        loading: false,
        data: [],
        meta: {},
        pagination: {
          page: 1,
          perPage: 50
        },
        sorting: {
          sortBy: 'id',
          desc: true
        }
      },
      filters: {}
    }
  },
  computed: {
    filtersActive() {
      for (const field of Object.keys(this.filters)) {
        if (typeof this.filters[field] === 'object' && this.filters[field] !== null) {
          const allKeys = Object.keys(this.filters[field])

          for (const key of allKeys) {
            if (Array.isArray(this.filters[field][key])) {
              if (this.filters[field][key].length) return true
            } else if (this.isValue(this.filters[field][key])) {
              return true
            }
          }
        } else if (Array.isArray(this.filters[field])) {
          if (this.filters[field].length) return true
        } else if (this.isValue(this.filters[field])) {
          return true
        }
      }

      return false
    }
  },
  beforeCreate() {
    // initialize emptyFilters in component
  },
  created() {
    this.filters = cloneDeep(this.emptyFilters)
  },
  watch: {
    filters: {
      deep: true,
      handler: function () {
        if (this.items.pagination.page === 1) {
          this.fetchItems()
        }
        this.items.pagination.page = 1
      }
    }
  },
  methods: {
    fetchItems: debounce(async function(loading = true) {
      this.items.loading = loading

      try {
        const queryParams = {
          page: this.items.pagination.page,
          per_page: this.items.pagination.perPage,
          order_by: this.items.sorting.sortBy,
          order: this.items.sorting.desc ? 'desc' : 'asc',
          ...this.filters
        }

        const result = await this.itemsFetcher(queryParams)

        this.items.data = result.data
        this.items.meta = result.meta

        // this.$vuetify.goTo(0)
      } finally {
        this.items.loading = false
      }
    }, 350),
    async itemsFetcher() {
      // override in component
    },
    clearFilters: function () {
      this.filters = cloneDeep(this.emptyFilters)
    },
    isValue: function (value) {
      return value !== undefined && value !== null && value !== ''
    }
  }
}

export default fetchableItemsMixin
